import {Component, EventEmitter, Input, Output} from '@angular/core';
@Component({
    selector: 'app-partner-downgrade-offer-sent',
    templateUrl: './partner-downgrade-offer-sent.component.html',
    standalone: false
})
export class PartnerDowngradeOfferSentComponent {
  @Input() customerEmail: string;
  @Output() next = new EventEmitter();
}
